<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
_/                                                                                                                    _/
_/      子画面定義：処理中画面(STFMFM02C18)                                                                           _/
_/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <button id="process" type="button" data-role="popup-open" data-target="#popup-upload"
    style="visibility: hidden"></button>
  <div class="overlay" id="popup-process" style="z-index:1001" 
    :class="[isProcessingCompleteShow ? showClass : hideClass]">
    <!-- <div class="popup"> -->
    <div class="popup" style="width: 414px">
      <div class="popup-head">処理中</div>
      <div class="popup-body blue" style="padding-left:30px;padding-right:30px">
        <div class="loading-gif">
          <img src="@/assets/images/denchouhou/Process.gif" alt="" width="100" height="100" class="popup-status-image " />
        </div>
        <div class="process-status" style="justify-content: flex-start;margin-bottom: 0;">
          <span style="margin-right: 8px;">処理進捗</span>
          <div class="process-status-wrap" style="flex:1 0 0">
            <div class="progress" style="margin-bottom:20px">
              <div class="progress-bar" :style="('width: ' + this.percentage + '%')"></div>
            </div>

          </div>

        </div>
        <div style="display:block;text-align: center;">
          <span class="register-size">{{ this.progressFlg ? "アップロード中" : "AI-OCR読み取り中" }}</span>
          <span class="register-size">（{{ this.submittedCount }} ／ {{ this.fileCount
          }}）ファイル</span>

        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { API_STFMFM02C18 } from "@/api/Modules/FM02/STFMFM02C18.js";
export default {
  name: "STFMFM02C18ProcessingModal",
  components: {
  },
  data() {
    return {
      showClass: "show",
      hideClass: "hide",
      percentage: 0,
      //処理件数
      submittedCount: 1,
      //処理全件数
      fileCount: 1,
      //進捗状態（完了：0、初期値：1）
      progressStatus: 1,
      // タイマー用
      timerID: null,
      loadingTimer: null,
      progressFlg: true,
      upFlg: true,
      ocrFlg: true
    };
  },
  props: {
    isProcessingCompleteShow: {
      type: Boolean,
      required: true,

    },
    pfileCount: {
      type: Number,
      required: true,
    },
  },
  watch: {
    isProcessingCompleteShow: function (newVal) {
      if (newVal) {
        this.fileCount = this.pfileCount;
        // 進捗パー
        this.percentage = _.divide(this.submittedCount, this.fileCount) * 100;
        // タイマー、1000ミリ秒で一this.countup()回実行
        this.getResults()
      } else {
        if(this.timerID){
          this.clearGetResultsTimer()
        }
      }
    },
  },
  methods: {
    getResults() {
      this.timerID = setInterval(() => { this.initialize() }, 3000)
    },
    clearGetResultsTimer() {
      clearInterval(this.timerID)
    },
    initialize() {
      this.errors = [];
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      // 処理進捗取得処理
      API_STFMFM02C18(config).then((response) => {
        // 正常終了の場合
        if (_.eq(response.result, "0000")) {
          this.progressStatus = response.progressStatus;
          this.fileCount = response.fileCount;
          if (response.progressStatus == 2) {
            this.progressFlg = false;
            // ファイル件数
            if (this.ocrFlg) {
              this.submittedCount = 1;
              this.ocrFlg = false;
            } else {
              if (this.submittedCount < response.submittedCount) {
                this.submittedCount = response.submittedCount;
              }
            }
          } else {
            // ファイル件数
            if (this.upFlg) {
              this.submittedCount = 1;
              this.upFlg = false;
            } else {
              if (this.submittedCount < response.submittedCount) {
                this.submittedCount = response.submittedCount;
              }
            }
          }
          if (response.progressStatus == 0) {
            // 進捗パー
            this.percentage = 100;
            // タイマー停止
            this.$emit("onsuccessed")
            this.clearGetResultsTimer()
          } else {
            // 進捗パー
            this.percentage = _.divide(this.submittedCount, this.fileCount) * 100;
          }
        } else {
          // タイマー停止
          this.clearGetResultsTimer()
          this.$emit("disagree");
        }
      }).catch((error)=>{
          this.clearGetResultsTimer()
          this.$emit("disagree");
      });

    }
  }
};
</script>
<style scoped>
.loading-gif {
  text-align: center;
}
</style>